<template>
  <div
    class="ms-input ms-editor w-100"
    :class="{
      'ms-validate': isValidate,
      'ms-input--has-right-icon': rightIcon,
      'ms-input--has-left-icon': leftIcon,
      'ms-input--has-clear-btn': isShowClearBtn && internalText,
      [ControlValidateClass]: isValidate,
    }"
  >
    <label v-if="label" class="label">{{ label }}<span v-if="isRequire" class="required">*</span></label>
    <div
      class="flex-row"
      :class="[
        { error: errorMessage || isErrorBorder, disabled: disabled },
        hasBorder ? 'border' : '',
      ]"
    >
      <div
        v-if="leftIcon"
        :class="['icon24 icon left', leftIcon]"
        @click="leftIconClick"
      />

      <input
        v-if="trimModel"
        ref="input"
        v-model.trim="internalText"
        v-auto-focus="isAutoFocus"
        :title="isShowTitle ? internalText: ''"
        class="ms-input-item flex w-100"
        :placeholder="placeholder"
        :disabled="disabled"
        :readOnly="readOnly"
        :maxlength="maxLength"
        :class="{ disabled: disabled }"
        :type="typeInput"
        v-on="listeners"
      >

      <input
        v-else
        ref="input"
        v-model="internalText"
        v-auto-focus="isAutoFocus"
        :title="isShowTitle ? internalText: ''"
        class="ms-input-item flex w-100"
        :placeholder="placeholder"
        :disabled="disabled"
        :readOnly="readOnly"
        :maxlength="maxLength"
        :class="{ disabled: disabled }"
        :type="typeInput"
        v-on="listeners"
      >

      <!-- Clear btn -->
      <div
        v-if="isShowClearBtn && internalText"
        class="ms-input-clear-btn"
        @click="handleClickClearBtn"
      />

      <div v-if="rightIcon" class="ic-right">
        <div
          :class="['icon24 icon', rightIcon]"
          @click="onClickRightIcon"
        />
      </div>
    </div>
    <div v-if="errorMessage" class="error-text items-center">
      <div v-if="isErrorIcon" class="icon16 ic_error mr-1" />
      <div>
        {{ errorMessage }}
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  nextTick,
  getCurrentInstance,
} from 'vue';
import msBaseComponent from '@/components/base/MsBaseComponent.vue';
import { useValidateControl, ControlValidateClass } from '@/setup/validateControl.js';
export default defineComponent({
  name: 'MsInput',
  extends: msBaseComponent,
  props: {
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    modelValue: {
      type: String,
      default: '',
    },
    /**
     * Có hiện nút xóa nhanh ko
     */
    isShowClearBtn: {
      type: Boolean,
      default: false,
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    placeholder: {
      default: null,
      type: [Number, String],
    },
    /**
     * Có tự đông focus khi mounted ko
     */
    isAutoFocus: {
      type: Boolean,
      default: false,
    },
    //icon left
    leftIcon: {
      default: null,
      type: String,
    },
    // Có focus vào input khi bấm vào left icon ko
    isFocusInputWhenClickLeftIcon: {
      default: true,
      type: Boolean,
    },
    //icon right
    rightIcon: {
      default: null,
      type: String,
    },
    // Có focus vào input khi bấm vào right icon ko
    isFocusInputWhenClickRightIcon: {
      default: true,
      type: Boolean,
    },
    //Giới hạn nhập của ô input
    maxLength: {
      default: null,
      type: Number,
    },
    //disabled
    disabled: {
      default: false,
      type: Boolean,
    },
    // Xác định xem input có border hay không?
    hasBorder: {
      default: true,
      type: Boolean,
    },
    /*
     * Hàm show ra câu thông báo riêng theo từng trường hợp
     * pvduy 18/03/2021
     * ví dụ: customWarring {rules:'required', mes: 'Tài sản này là của pvduy'}
     */
    customWarring: {
      type: Object,
      default: null,
    },
    /**
     * Có được click icon hay không?
     * NNLINH 27.06.2022
     */
    isClickRightIcon: {
      default: false,
      type: Boolean,
    },
    trimModel: {
      default: true,
      type: Boolean,
    },
    /**
     * Loại input
     * NQLOI 28.03.2023
     */
    typeInput: {
      type: String,
      default: 'text'
    },
    /**
     * Có hiện title hay không
     */
    isShowTitle: {
      type: Boolean,
      default: true
    },
    /**
     * Có bôi đỏ border hay không
     */
    isErrorBorder: {
      type: Boolean,
      default: false
    },
    /**
     * Có hiển thị icon lỗi khi validate không
     */
    isErrorIcon: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'msKeydown',
    'update:modelValue',
    'focus',
    'blur',
    'change',
    'msKeyup',
    'clickRightIcon',
  ],
  setup(props, { emit }) {
    //Variable
    let internalText = ref('');
    let focused = false;
    let displayValue = null;
    let scrollWidth = 0;
    let input = ref(null);
    const {
      errorMessage,
      validate,
      isValidate,
      clearValidate,
      validated,
      focusError,
    } = useValidateControl({
      props,
    }, input);

    const { proxy } = getCurrentInstance();

    const isRequire = computed(()=> {
      return props.rules.find(rule => rule.name = 'required')
    })

    //Method
    const hasTooltip = () => {
      if (scrollWidth > input?.value?.offsetWidth) {
        return true;
      }
      return false;
    };

    //Sự kiện focus vào ô input
    const onFocus = (e) => {
      focused = true;
      emit('focus', internalText.value, e);
    };

    //Sự kiên blur ra ngoài ô input
    const onBlur = (e) => {
      focused = false;
      // Nếu có rule và đã validate 1 lần rồi thì mới validate khi blur
      if (isValidate.value && validated.value) {
        validate();
      }
      emit('blur', internalText.value, e);
    };

    /**
     * Sự kiện Click icon bên phải ô Input
     * NNLINH 27.06.2022
     */
    const onClickRightIcon = () => {
      // Nếu đc focus khi bấm vào icon bên phải thì focus
      if (input.value && props.isFocusInputWhenClickRightIcon) {
        input.value.focus();
      }
      if (props.isClickRightIcon) {
        emit('clickRightIcon');
      }
    };

    /**
     * Focus input khi bấn left icon
     * @author: BMThang(06/11/2022)
     */
    const leftIconClick = () => {
      // Nếu đc focus khi bấm vào icon bên trái thì focus
      if (input.value && props.isFocusInputWhenClickLeftIcon) {
        input.value.focus();
      }
    };

    //Reset lại giá trị về ban đầu
    const reset = () => {
      internalText.value = '';
      displayValue = null;
    };
    //Set giá trị cho ô input
    const setValue = (value) => {
      if (proxy.rules) {
        const rule = proxy.rules.find(
          (x) => x.name === 'pattern' && x.compareValue === 'phone'
        );
        if (rule && value) {
          value = value.replace(/ /g, '').replace(/\./g, '');
        }
      }
      internalText.value = value;
    };

    //Lấy giá trị ô input
    const getValue = () => {
      return internalText.value;
    };

    /**
     * Hủy lan rộng event
     * HTHIEP 09.02.2022
     */
    const cancelEvent = (e) => {
      if (e) {
        if (typeof e.preventDefault === 'function') {
          e.preventDefault();
        }

        if (typeof e.stopPropagation === 'function') {
          e.stopPropagation();
        }

        if (typeof e.stopImmediatePropagation === 'function') {
          e.stopImmediatePropagation();
        }
      }
    };

    //Hooks
    //set internalText
    onMounted(() => {
      internalText.value = props.modelValue;
    });

    /**
     * Lắng nghe event => thò ra ngoài
     * HTHIEP 11.02.2022: Làm mịn, migration sang vue 3
     */
    const listeners = computed(() => {
      return {
        blur: (e) => {
          cancelEvent(e);
          onBlur(e);
        },
        focus: (e) => {
          cancelEvent(e);
          onFocus(e);
        },
        change: (e) => {
          cancelEvent(e);
          emit('change', e, internalText.value);
        },
        keydown: (e) => {
          e.stopPropagation();
          emit(proxy.$ms.constant.CustomEvent.MsKeydown, e, internalText.value);
        },
        keyup: (e) => {
          emit('msKeyup', e, internalText.value);
        },
      };
    });

    /**
     * Xóa giá trị và focus vào input khi nhấn nút xóa
     * @author: BMThang(16/12/2022)
     */
    const handleClickClearBtn = () => {
      reset();
      if (input.value && props.isFocusInputWhenClickRightIcon) {
        input.value.focus();
      }
    }

    /**
     * Lắng nghe xử lý update lại modelValue
     * HTHIEP 11.02.2022: Làm mịn, sửa lại từ vue 2 sang vue 3
     */
    watch(
      () => internalText.value,
      (value) => {
        if (value !== props.modelValue) {
          emit('update:modelValue', value);
          scrollWidth = input.value.scrollWidth;
        }
      }
    );

    /**
     * Lắng nghe thay đổi modelValue set lại text cho input
     * HTHIEP 11.02.2022: Làm mịn, sửa lại từ vue 2 sang vue 3
     */
    watch(
      () => props.modelValue,
      (value) => {
        setValue(value);
      }
    );
    return {
      internalText,
      focused,
      listeners,
      reset,
      hasTooltip,
      displayValue,
      input,
      getValue,
      errorMessage,
      validate,
      isValidate,
      clearValidate,
      onClickRightIcon,
      leftIconClick,
      ControlValidateClass,
      focusError,
      isRequire,
      handleClickClearBtn,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
@import '@/assets/scss/components/MsInput.scss';
</style>
